/* eslint-disable react-hooks/exhaustive-deps */
import EditIcon from '@mui/icons-material/Edit';
import './datagrid.css';
import { alpha, styled } from '@mui/material/styles';
// eslint-disable-next-line
import {
  DataGridPremium as MuiDataGridPremium,
  DataGridPremiumProps,
  GridColDef,
  GridSortModel,
  GridValueGetterParams,
  GridRowModel,
  GridApi,
  GridRowParams,
  GridFilterModel,
  GridRowSelectionModel,
  GridCallbackDetails,
  GridCellParams,
  GridColumnHeaderParams,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridValidRowModel,
  useGridApiRef,
  GridRowId,
  enUS,
  ruRU,
  frFR,
  trTR,
  getGridStringOperators,
  GridFilterItem,
  GridNativeColTypes,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridToolbarExport,
  GridColumnVisibilityModel,
} from '@mui/x-data-grid-premium';
import { useCallback, useContext, useEffect, useState } from 'react';
import { Box, darken, lighten } from '@mui/material';
import Stack from '../Stack';
import { CustomThemeContext } from 'src/theme/ThemeProvider';
import { Localization } from '@mui/x-data-grid/utils/getGridLocalization';
//export type { ValueOptions } from '@mui/x-data-grid';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { azAZ } from '@mui/material/locale';
import { helper } from "src/utils/helper";
import Typography from "../Typography";
import IconButton from '../IconButton';
import {
  useCrateDataGridPropsMutation,
  useGetDataGridPropsQuery,
  useUpdateDataGridPropsMutation,
  useDeleteDataGridPropsMutation
} from 'src/services/Genel/DatarGridApi';
import { useAppSelector } from 'src/store';
import VwDatagridpropsDTO from 'src/models/Genel/VwDatagridpropsDTO';
import { DatagridType } from './type';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export declare type TGridColType = GridNativeColTypes | "currency" | "time" | "checkboxSelection";
type actions = "action" | "action2" | "action3" | "action4" | "action5";
export type IGridColDef<T> = GridColDef<T> & {
  field: keyof T & string | actions,
  type?: TGridColType,
  noThousandSeparator?: boolean,
  decimalScale?: number
}

export type IGridValueGetterParams = GridValueGetterParams & {};

export interface IGridRowModel extends GridRowModel { }

export interface IGridApi extends GridApi { }


export interface IGridRowParams extends GridRowParams { }

export declare interface IGridFilterModel extends GridFilterModel { }

export interface IGridRowSelectionModel extends GridRowSelectionModel { }

export interface IGridCallbackDetails extends GridCallbackDetails { }

export interface IGridSortModel extends GridSortModel { }

export interface IGridCellParams extends GridCellParams { }

export interface IGridColumnHeaderParams extends GridColumnHeaderParams { }

export const useCustomGridApiRef = useGridApiRef
export type customGridRowId = GridRowId
export interface IDataGridPremiumProps<R = GridValidRowModel> extends DataGridPremiumProps<R> {
  hiddenColumnsButton?: boolean;
  hiddenFilters?: boolean;
  hiddenExport?: boolean;
  addHeaderColumn?: React.ReactNode;
  addButton?: React.ReactNode;
  searchButton?: React.ReactNode;
  backButton?: React.ReactNode;
  printButton?: React.ReactNode;
  columns: Array<IGridColDef<R>>;
  enableQuickFilter?: boolean;
  id?: DatagridType;
  colPropsButton?: boolean;
  columnVisibilityModel?: {
    [K in keyof R | actions]?: boolean
  };
  pinnedColumns?: {
    left?: Array<keyof R & string | actions>;
    right?: Array<keyof R & string | actions>;
  }
  disableScrollToIndex?: boolean;
}
const ODD_OPACITY = 0.2;
const StripedDataGrid = styled(MuiDataGridPremium, { shouldForwardProp: (prop) => prop !== 'headerRadius' })<{
  headerRadius?: boolean;
}>(({ theme, headerRadius, initialState }) => ({
  '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitle': {
    whiteSpace: 'normal',
    lineHeight: "16px"
  },
  '&.MuiDataGrid-root .MuiDataGrid-footerContainer': {
    minHeight: '0px',
    height: "0px",
    padding: "13px"
  },
  '&.MuiDataGrid-root .MuiDataGrid-columnHeaders': {
    borderRadius: headerRadius ? `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0px 0px` : "0px",
    //backgroundColor: theme.palette.mode == "dark" ? darken(theme.palette.primary.main,0.5) : lighten(theme.palette.primary.main,0.8),
    backgroundImage: `linear-gradient(to bottom right, ${theme.palette.mode == 'dark'
      ? darken(theme.palette.primary.main, 0.5)
      : lighten(theme.palette.primary.main, 0.8)
      }, ${theme.palette.background.paper})`
  },
  '&.MuiDataGrid-root .MuiDataGrid-columnHeader--sortable': {
    backgroundColor: 'transparent',
  },
  [`& .${gridClasses.row}.odd`]: {
    backgroundColor: theme.palette.background.paper,
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    '&.Mui-selected': {
      backgroundColor: alpha(theme.palette.primary.main, 0.5),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity
          )
        }
      }
    }
  },
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.background.default,
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    '&.Mui-selected': {
      backgroundColor: alpha(theme.palette.primary.main, 0.5),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity
          )
        }
      }
    }
  },
}));
const getColCount = (_props: IDataGridPremiumProps<any>): number => {
  let colCount = 0;
  if (_props.addButton)
    colCount++;
  if (_props.searchButton)
    colCount++;
  if (_props.backButton)
    colCount++;
  if (_props.printButton)
    colCount++;
  if (!_props.hiddenColumnsButton && !_props.hiddenExport && !_props.hiddenFilters && !_props.colPropsButton)
    colCount++;
  return colCount;
}

const DataGrid = <R extends GridValidRowModel>(_props: IDataGridPremiumProps<R>): JSX.Element => {
  //const DataGridComponent = props.gridTheme === 'ant' ? AntDesignStyledDataGrid : MuiDataGrid;
  const { columns, hiddenColumnsButton, hiddenExport, hiddenFilters, addHeaderColumn,
    backButton, searchButton, addButton, enableQuickFilter, colPropsButton, printButton, columnVisibilityModel,
    ...props } = _props;

  let colCount = getColCount(_props);
  const formsize = useAppSelector(s => s.userLogin.formSize)
  const apiref = useGridApiRef();
  const userId = useAppSelector(s => s.userLogin.userInfo.id)
  const query = useGetDataGridPropsQuery({
    kullaniciId: userId,
    datarGridId: _props.id
  }, { skip: userId && _props.id ? false : true });
  const create = useCrateDataGridPropsMutation();
  const update = useUpdateDataGridPropsMutation();
  const del = useDeleteDataGridPropsMutation();
  const [userColumn, setUserColumn] = useState<Array<IGridColDef<R>>>([]);
  const [userVisibleCol, setUserVisibleCol] = useState<GridColumnVisibilityModel>();
  const [userColumnOrder, setUserColumnOrder] = useState<Array<string>>([]);
  let padding = 0;
  if (colCount > 0)
    padding = 5;

  useEffect(() => {
    if (!apiref || _props.apiRef) return;
    if (query?.data?.length > 0) {
      const parsedColText = JSON.parse(query?.data[0]?.coltext);
      setUserColumn(parsedColText);
      if (query?.data[0]?.colVisibility !== null && query?.data[0]?.colVisibility !== "" && query?.data[0]?.colVisibility !== undefined) {
        setUserVisibleCol({
          ...columnVisibilityModel,
          ...JSON.parse(query?.data[0]?.colVisibility)
        });
      }
      if (query?.data[0]?.colOrder !== null && query?.data[0]?.colOrder !== "" && query?.data[0]?.colOrder !== undefined) {
        setUserColumnOrder(JSON.parse(query?.data[0]?.colOrder));
      } else {
        setUserColumnOrder(parsedColText.map(col => col.field));
      }
    }
  }, [query.data]);

  const GridVisibilityHandleChange = (p: GridColumnVisibilityModel) => {
    setUserVisibleCol(p);
  };

  const handleColumnOrderChange = (newOrder: Array<string>) => {
    setUserColumnOrder(newOrder);
    colPropsSaveHandle();
  };

  const colPropsSaveHandle = () => {
    if (!_props.colPropsButton) return;
    var item = JSON.stringify(apiref.current.getAllColumns() as Array<IGridColDef<R>>);
    var colOrder = JSON.stringify(apiref.current.getAllColumns().map(col => col.field));

    if (query?.data?.length > 0) {
      update[0]({
        ...new VwDatagridpropsDTO(),
        id: query?.data[0].id,
        coltext: item,
        datagridId: query?.data[0].datagridId,
        kullaniciId: query?.data[0]?.kullaniciId,
        colVisibility: JSON.stringify(userVisibleCol),
        colOrder: colOrder,
      }).unwrap().then(() => {
        query.refetch();
      }).catch((err) => err)
    }
    else {
      create[0]({
        ...new VwDatagridpropsDTO(),
        id: 0,
        coltext: item,
        colVisibility: JSON.stringify(userVisibleCol),
        datagridId: props.id,
        kullaniciId: userId,
        colOrder: colOrder,
      }).unwrap().then(() => {
        query.refetch();
      }).catch((err) => err)
    }
  }

  const colPropDeleteHandle = () => {
    if (query?.data?.length > 0) {
      del[0](query.data[0].id).unwrap().then(() => {
        query.refetch();
      }).catch((err) => err)
    }
  }

  const themeContext = useContext(CustomThemeContext)
  const CustomToolbar = (): JSX.Element => {
    return (
      <GridToolbarContainer style={{ padding }}>
        <Box display="flex" sx={{ flexGrow: 1 }}>
          <Box display={"flex"} alignItems={"center"}>
            <Stack direction={"row"} spacing={1}>
              {backButton && <Box sx={{ minWidth: 150 }}>{backButton}</Box>}
              {searchButton && <Box sx={{ minWidth: 150 }}>{searchButton}</Box>}
              {addButton && <Box sx={{ minWidth: 150 }}>{addButton}</Box>}
              {printButton && <Box sx={{ minWidth: 150 }}>{printButton}</Box>}
            </Stack>
          </Box>
          <Box flexGrow={1} display="flex" paddingLeft={2}>
            {addHeaderColumn}
          </Box>
          <Box display="flex">
            <Stack
              direction="row"
              spacing={2}
            >
              {enableQuickFilter && <GridToolbarQuickFilter
                debounceMs={500}
              ></GridToolbarQuickFilter>}
              {colPropsButton && <IconButton loading={create[1].isLoading ? create[1].isLoading : update[1].isLoading} onClick={() => colPropsSaveHandle()} sx={{ minWidth: 16, padding: 0 }} color="primary" customType="gridColSave" />}
              {colPropsButton && <IconButton loading={del[1].isLoading} onClick={() => colPropDeleteHandle()} sx={{ minWidth: 16, padding: 0 }} color="primary" customType="gridColDel" toolTip='' />}
              {!hiddenColumnsButton && <GridToolbarColumnsButton sx={{ minWidth: 16, padding: 0 }} />}
              {!hiddenFilters && <GridToolbarFilterButton sx={{ minWidth: 16, padding: 0 }} />}
              {!hiddenExport && <GridToolbarExport sx={{ minWidth: 16, padding: 0 }} />}
            </Stack>
          </Box>
        </Box>
      </GridToolbarContainer >
    );
  };

  let langObject: Localization;
  switch (themeContext.lang) {
    case "AZ":
      langObject = trTR;
      langObject.components.MuiDataGrid.defaultProps.localeText.MuiTablePagination = azAZ.components.MuiTablePagination.defaultProps;
      break;
    case 'US':
      langObject = enUS;
      break;
    case "RU":
      langObject = ruRU;
      break;
    case 'FR':
      langObject = frFR;
      break;
    default:
      langObject = trTR;
      langObject.components.MuiDataGrid.defaultProps.localeText.headerFilterOperatorContains = "";
      langObject.components.MuiDataGrid.defaultProps.localeText.headerFilterOperatorIs = "";
      break;
  }

  /**
   * Verilen sayının yüzden küçük veya eşit olana kadar kaç basamağa sahip olduğunu bulan fonksiyon.
   *
   * @param {number} sayi - Basamak sayısı bulunacak olan sayı.
   * @param {number} [basamak=0] - Başlangıç basamağı. Varsayılan değeri 0'dır.
   * @returns {number} - Sayının yüzden küçük veya eşit olana kadar kaç basamağa sahip olduğu.
   */
  const sayfaDegeriBul = (sayi: number, basamak: number = 0): number => {
    // Eğer sayı 100 veya daha küçükse, başlangıç basamağını geri döndür.
    if (sayi <= 100) {
      return basamak;
    } else {
      // Sayıyı 100 birim azaltarak ve basamak sayısını bir birim artırarak fonksiyonu tekrar çağır.
      return sayfaDegeriBul(sayi - 100, basamak + 1);
    }
  };
  /**
   * Mui datagridde sorting yapıldığında datanın ona göre döndürülüp scroll ve page'nin ayarlanmasında kullanılan fonksiyon 
   * @returns 
  */
  const rowsData = (): GridRowId[] => {
    if (!props.treeData) {
      const sortingData = apiref.current?.getSortModel()?.length > 0;
      if (sortingData)
        return apiref.current?.getSortedRowIds(); //sorting rows'daki dataların hepsini alır.
      return apiref.current?.getAllRowIds(); //rows'daki dataların hepsini alır.
    }
  };
  /**
   * DataGrid kullanılan bölümlerde component mount olduğunda çalışan tetikleyici
   * rowSelectionModel'e bağımlı olarak çalışır.
   * rowSelectionModel'de tanımlı idlere göre data içerisinde index'i bulup fonksiyon aracılığıyla bulunduğu page'i ve scroll'un ineceği alanı bulup oraya odaklanır.
  */
  const setPageToScrollIndex = useCallback(() => {
    setTimeout(() => {
      const bul: Array<number> = _props.rowSelectionModel as any; //bul'a rowSelectionModel verilir.
      if (bul?.length > 0) { //Array içerisinde kayıt bulunuyorsa if içerisine girer
        const data = rowsData();
        if (data?.length > 0) {
          const bulIndex = data.findIndex((v) => v === bul[0]); //rowsdaki bulduğu data üzerinden bul[0] kaydının index'i bulunur. 
          let pageIndex = sayfaDegeriBul(bulIndex); //sayfaDegeriniBul fonksiyonu aracılığıyla index'in basamağı bulunur.
          apiref.current.setPaginationModel({ page: pageIndex, pageSize: 100 }); //apiref aracılığıyla paginate çalıştırılır. (Önce scroll çalıştırılmamalı page yaparsa scroll gider).
          apiref.current.scrollToIndexes({ colIndex: 0, rowIndex: bulIndex }); //paging set olduktan sonra scroll o indexe focuslandırılır.
        }
      }
    }, 0);
  }, [_props.rowSelectionModel]);
  useEffect(() => {
    if(props.disableScrollToIndex === false || props.disableScrollToIndex === null || props.disableScrollToIndex === undefined){
    setPageToScrollIndex();
    }
  }, [setPageToScrollIndex]);

  return ( //TODO: userVisibleCol &&  TODO: Column visibility customize edilemedi tekrar bakılacak.
    <StripedDataGrid
      {...props}
      headerRadius={getColCount(_props) === 0}
      slots={{
        ...props?.slots,
        toolbar: CustomToolbar,
        booleanCellFalseIcon: (param) => {
          return <CheckBoxOutlineBlankIcon
            sx={{
              color: (theme) => theme.palette.primary.dark,
              fontSize: formsize * 2
            }}
          ></CheckBoxOutlineBlankIcon>
        },
        booleanCellTrueIcon: (param) => {
          return <CheckBoxIcon
            sx={{
              color: (theme) => theme.palette.primary.main,
              fontSize: formsize * 2
            }}
          ></CheckBoxIcon>
        },
        detailPanelCollapseIcon: (props) => {
          return <KeyboardArrowUpIcon />
        },
        detailPanelExpandIcon(props) {
          return <KeyboardArrowDownIcon />
        },
      }}

      columns={columns.map((m, i) => {
        if (m.type === "string" || !m.type) {
          m.filterOperators = getGridStringOperators().map(f => {
            f.getApplyFilterFn = (filterItem: GridFilterItem, column: GridColDef) => {
              return (params: GridCellParams): boolean => {
                if (filterItem.operator === "contains") {
                  return helper.UpperCaseAsc(helper.objectToString(params.value))?.indexOf(helper.UpperCaseAsc(filterItem.value)) > -1
                }
                if (filterItem.operator === "equals") {
                  return helper.UpperCaseAsc(helper.objectToString(params.value)) === helper.UpperCaseAsc(filterItem.value)
                }
                if (filterItem.operator === "startsWith") {
                  return helper.UpperCaseAsc(helper.objectToString(params.value))?.indexOf(helper.UpperCaseAsc(filterItem.value)) === 0
                }
                if (filterItem.operator === "endsWith") {
                  return helper.UpperCaseAsc(helper.objectToString(params.value))?.lastIndexOf(helper.UpperCaseAsc(filterItem.value)) === filterItem.value?.length
                }
                if (filterItem.operator === "isEmpty") {
                  return params.value === ""
                }
                if (filterItem.operator === "isNotEmpty") {
                  return params.value !== ""
                }
                return Number(params.value) >= Number(filterItem.value);
              };
            }
            m.getApplyQuickFilterFn = (value: string) => {
              return (params: GridCellParams): boolean => {
                return helper.UpperCaseAsc(helper.objectToString(params.value))?.indexOf(helper.UpperCaseAsc(value)) > -1
              };
            }
            return f;
          })
        }
        if (m.editable && !m.cellClassName && props.editMode === "cell") {
          m.renderHeader = params => {
            return <>
              <Typography>{params.colDef.headerName}</Typography>
              <EditIcon sx={{ paddingBottom: 1 }} color="primary"></EditIcon>
            </>
          }
        }
        if ((m.renderCell && !m.cellClassName && props.editMode === "cell") && (m.field !== "action" && m.field !== "action2")) {
          m.renderHeader = params => {
            return <>
              <Typography>{params.colDef.headerName}</Typography>
              <EditIcon sx={{ paddingBottom: 1 }} color="primary"></EditIcon>
            </>
          }
        }
        if (m.type === "date" && !m.valueFormatter) {
          m.align = "center";
          m.valueFormatter = (params) => {
            if (params.value) {
              let date;

              if (params.value instanceof Date) {
                date = params.value;
              } else {
                date = new Date(params.value);
              }

              if (!isNaN(date.getTime())) {
                const locale = helper.getLocaleFromLang(localStorage.getItem('lang'));
                return date.toLocaleDateString(locale, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit"
                });
              }
            }
            return null;
          };
        }
        if (m.type === "date" && !m.valueGetter) {
          m.valueGetter = (params) => {
            if (!params.value) return null;

            let date;
            if (params.value instanceof Date) {
              date = params.value;
            } else {
              try {
                date = new Date(params.value);
                if (isNaN(date.getTime())) return null;
              } catch (error) {
                return null;
              }
            }
            return new Date(Date.UTC(
              date.getFullYear(),
              date.getMonth(),
              date.getDate()
            ));
          };
        }
        if (m.type === "dateTime" && !m.valueFormatter) {
          m.valueFormatter = (params) => {
            if (params.value) {
              let date;

              if (params.value instanceof Date) {
                date = params.value;
              } else {
                date = new Date(params.value);
              }

              if (!isNaN(date.getTime())) {
                const locale = helper.getLocaleFromLang(localStorage.getItem('lang'));
                return date.toLocaleString(locale, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit"
                });
              }
            }
            return null;
          }
        }

        if (m.type === "dateTime" && !m.valueGetter) {
          m.valueGetter = (params) => {
            if (!params.value) return null;
            let date;
            if (params.value instanceof Date) {
              date = params.value;
            } else {
              try {
                date = new Date(params.value);
                if (isNaN(date.getTime())) return null;
              } catch (error) {
                return null;
              }
            }

            // Ensure the date is valid before proceeding
            if (isNaN(date.getTime())) return null;

            // Return the date as is, without converting to UTC
            return date;
          };
        }
        if (m.type === "time" && !m.valueFormatter) {
          m.valueFormatter = (params) => {
            return helper.jsonToTimeString(params.value)
          }
        }
        if (m.type === "currency" && !m.valueFormatter) {
          m.align = "right";
          m.valueFormatter = (params) => {
            if (!params.value) {
              return params.value;
            }
            return helper.formatNumber(params.value, m.decimalScale)
          }
        }
        if (m.type === "number" && !m.valueFormatter && m.noThousandSeparator) {
          m.align = "right";
          m.valueFormatter = (params) => {
            return params.value;
          }
        }

        if (m.type === "number" && !m.valueFormatter && m.decimalScale > 0) {
          m.align = "right";
          m.valueFormatter = (params) => {
            if (isNaN(params?.value)) {
              return null;
            };
            return helper.formatNumber(Number(params?.value), Number(m?.decimalScale));
          };
        }

        if (m.availableAggregationFunctions) {
          m.renderHeader = (params) => {
            return <b>{params.colDef.headerName}</b>
          }
        }
        switch (m.field) {
          case "action":
          case "action2":
          case "action3":
          case "action4":
          case "action5":
            m.hideable = false;
            m.disableColumnMenu = true;
            m.sortable = false;
            m.disableExport = true;
            m.disableReorder = true;
            m.resizable = true;
            break;
        }
        var item = userColumn?.filter(f => f.field === m.field)[0];
        if (userColumn?.length > 0 && m.flex == 1 && m?.width != item?.width) {
          m.flex = 0;
          m.minWidth = null
          m.width = item.width
        }
        if (userColumn?.length > 0 && item?.width && m?.width)
          m.width = item?.width
        // if (userColumn?.length > 0)
        //   m.hideable = item?.hideable
        return m;
      }).sort((a, b) => userColumnOrder.indexOf(a.field) - userColumnOrder.indexOf(b.field))}
      // initialState={{
      //   columns: {
      //     columnVisibilityModel: userVisibleCol ? userVisibleCol : columnVisibilityModel
      //   }
      // }}
      //columns={columns}
      density={props.density ? props.density : "compact"}
      showCellVerticalBorder={!(props.showCellVerticalBorder === false)}
      showColumnVerticalBorder={!(props.showColumnVerticalBorder === false)}
      columnVisibilityModel={userVisibleCol}
      onColumnVisibilityModelChange={(m, d) => {
        // var item = apiref.current.getAllColumns() as Array<IGridColDef<R>>;
        // var colVisibility = apiref.current.getVisibleColumns() as Array<IGridColDef<R>>;

        // var visibleColumns = item.filter(p => colVisibility.includes(p));
        // var hiddenColumns = item.filter(p => !colVisibility.includes(p));
        if (props.onColumnVisibilityModelChange)
          props.onColumnVisibilityModelChange(m, d);
        else
          GridVisibilityHandleChange(m);

      }}
      onColumnOrderChange={(params) => {
        const newOrder = apiref.current.getAllColumns().map(col => col.field);
        handleColumnOrderChange(newOrder);
      }}
      // rowHeight={props.rowHeight > 0 ? props.rowHeight : 35}
      rowHeight={formsize * 3.5}
      columnHeaderHeight={formsize * 4}
      pagination={props.pagination === false ? false : true}
      localeText={{
        ...langObject.components.MuiDataGrid.defaultProps.localeText,
        toolbarColumns: "",
        toolbarFilters: "",
        toolbarDensity: "",
        toolbarExport: ""
      }}
      pageSizeOptions={!props.pageSizeOptions ? [25, 50, 100, 250, 500] : props.pageSizeOptions}
      getRowClassName={(params) => {
        if (props.getRowClassName)
          return props.getRowClassName(params as any);
        return params.indexRelativeToCurrentPage % 2 === 0
          ? 'even'
          : "odd";
      }}
      apiRef={_props.apiRef ? _props.apiRef : apiref}
    />
  );
};
export default DataGrid;
